import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const CreateOperatorForm = ({ employees = [], employeeSearch = '', setEmployeeSearch = () => {}, modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createTopBaseOperator, loadOperators = async () => {}, notifySuccess = () => {}, notifyError = () => {}, uploadOperatorDocuments }) => {
  const [selectedFiles, setSelectedFiles] = React.useState([])
  
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || [])
    setSelectedFiles(prevFiles => [...prevFiles, ...files])
  }
  
  const removeFile = (index) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index))
  }
  
  const handleCreate = async () => {
    try {
      const payload = { ...modalPayload }
      if (modalPayload.top_base_name) delete payload.top_base_name
      
      const response = await createTopBaseOperator(payload)
      const operatorId = response?.data?.id
      
      // Загружаем документы если есть
      if (selectedFiles.length > 0 && operatorId) {
        try {
          await uploadOperatorDocuments(operatorId, selectedFiles)
        } catch (docErr) {
          console.error('Failed to upload documents:', docErr)
          notifyError(docErr, 'Оператор создан, но не удалось загрузить документы')
        }
      }
      
      if (payload.top_base) await loadOperators(payload.top_base)
      closeModal()
      notifySuccess('Оператор создан')
    } catch (err) {
      console.error(err)
      notifyError(err, 'Не удалось создать оператора')
    }
  }
  
  return (
    <>
      <label>ТОП-База</label>
      <input placeholder="ТОП-База" value={modalPayload.top_base_name || modalPayload.top_base || ''} readOnly />

      <label>Сотрудник</label>
      <input
        placeholder="Поиск сотрудника..."
        value={employeeSearch}
        onChange={(e) => setEmployeeSearch(e.target.value)}
      />
      <select value={modalPayload.employee || ''} onChange={(e) => setModalPayload(p => ({ ...p, employee: Number(e.target.value) }))}>
        <option value="">— Выберите сотрудника —</option>
        {employees.filter(emp => (emp.label || '').toLowerCase().includes(employeeSearch.toLowerCase())).map(emp => (
          <option key={emp.id} value={emp.id}>{emp.label}</option>
        ))}
      </select>

      <label>Телефон</label>
      <input placeholder="Телефон" value={modalPayload.phone || ''} onChange={(e) => setModalPayload(p => ({ ...p, phone: e.target.value }))} />
      
      <label>Документы</label>
      <input 
        type="file" 
        multiple 
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
        onChange={handleFileChange}
      />
      {selectedFiles.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <strong>Выбранные файлы:</strong>
          <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
            {selectedFiles.map((file, index) => (
              <li key={index}>
                {file.name} ({(file.size / 1024).toFixed(1)} KB)
                <button 
                  type="button"
                  onClick={() => removeFile(index)}
                  style={{ marginLeft: 8, color: 'red', cursor: 'pointer', background: 'none', border: 'none' }}
                >
                  ✕
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
      
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}>Отмена</button>
        <button onClick={handleCreate} className={styles.btn_pin}>Создать</button>
      </div>
    </>
  )
}

export default CreateOperatorForm
